import {
  OrderByRelationWithColumnAggregateFunction,
  QueryWorkOrdersOrderByColumn,
  QueryWorkOrdersOrderByDeliveryAddressColumn,
  QueryWorkOrdersOrderByDepartureAddressColumn,
  QueryWorkOrdersOrderByRelationOrderByClause,
  QueryWorkOrdersOrderBySupplierColumn,
  QueryWorkOrdersWhereAssignmentsColumn,
  SortOrder,
  SqlOperator,
  WorkOrderListQueryVariables,
  WorkOrderStatus,
} from "@/gql/graphql";
import { GetQueryVariablesFn } from "@/lib/Components/DataTable/DataTable";
import { WorkOrderTableCols } from "@/app/ProDrivers/WorkOrders/Components/WorkOrderTable";

const orderMap: Record<string, QueryWorkOrdersOrderByColumn> = {
  id: QueryWorkOrdersOrderByColumn.Id,
  from: QueryWorkOrdersOrderByColumn.Id,
  to: QueryWorkOrdersOrderByColumn.Id,
  status: QueryWorkOrdersOrderByColumn.Status,
  created_at: QueryWorkOrdersOrderByColumn.CreatedAt,
  vehicle: QueryWorkOrdersOrderByColumn.VehicleType,
  depart_after: QueryWorkOrdersOrderByColumn.DepartAfter,
};

export function getWorkOrderQueryVariables({
  supplierId,
  status,
  relocationId,
  proDriverIds,
}: {
  supplierId: string | null;
  status: WorkOrderStatus[];
  relocationId?: string;
  proDriverIds?: string[];
}): GetQueryVariablesFn<WorkOrderListQueryVariables, WorkOrderTableCols> {
  const whereAssignments = proDriverIds?.length
    ? {
        column: QueryWorkOrdersWhereAssignmentsColumn.ProDriverId,
        operator: SqlOperator.In,
        value: proDriverIds,
      }
    : undefined;

  return ({ search, pagination, sorting }) => {
    if (search) {
      return {
        search,
        status: status.length > 0 ? status : undefined,
        page: pagination.pageIndex,
        first: pagination.pageSize,
        supplier_id: supplierId ?? undefined,
        relocation_id: relocationId,
      };
    }

    const orderBy: QueryWorkOrdersOrderByRelationOrderByClause[] = [];

    sorting.forEach((item) => {
      const order = item.desc ? SortOrder.Desc : SortOrder.Asc;
      if (item.id === "supplier") {
        orderBy.push({
          supplier: {
            aggregate: OrderByRelationWithColumnAggregateFunction.Max,
            column: QueryWorkOrdersOrderBySupplierColumn.Name,
          },
          order,
        });

        return;
      }

      if (item.id === "from") {
        orderBy.push({
          order,
          departureAddress: {
            aggregate: OrderByRelationWithColumnAggregateFunction.Max,
            column: QueryWorkOrdersOrderByDepartureAddressColumn.City,
          },
        });
      }

      if (item.id === "to") {
        orderBy.push({
          order,
          deliveryAddress: {
            aggregate: OrderByRelationWithColumnAggregateFunction.Max,
            column: QueryWorkOrdersOrderByDeliveryAddressColumn.City,
          },
        });
      }

      if (orderMap[item.id]) {
        orderBy.push({
          order,
          column: orderMap[item.id],
        });
        return;
      }

      console.warn(`Could not find order mapping for ${item.id}`);
    });

    return {
      page: pagination.pageIndex,
      first: pagination.pageSize,
      supplier_id: supplierId ?? undefined,
      relocation_id: relocationId,
      status: status.length > 0 ? status : undefined,
      whereAssignments,
      orderBy,
    };
  };
}
